import React from 'react';

export const Bubble = ({ size, left, duration, delay }) => {
  const style = {
    width: `${size}px`,
    height: `${size}px`,
    left: `${left}%`,
    bottom: '-20px',
    animationDuration: `${duration}s`,
    animationDelay: `${delay}s`,
  };

  return <div className="bubble" style={style} />;
};
